'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBoard = undefined;

var _reduxActions = require('redux-actions');

var loadBoard = exports.loadBoard = (0, _reduxActions.createAction)('LOAD_BOARD');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-trello/dist/actions/BoardActions.js
// module id = 1840
// module chunks = 0